/** Nav.tsx Basic navigation component */
import React from "react";
import { style, classes } from "./nav.st.css";
import { Links } from "../../components/types";
/** Nav props. */
interface NavProps
  extends React.HTMLAttributes<HTMLElement | HTMLAnchorElement> {
  items: Links;
  /** Nav hidden true sets the tab indexing to -1 and sets aria hidden */
  hidden?: boolean;
  ref?: string;
  /** Nav item when it's active / on a page */
  isActive?: boolean;
}

const defaultProps = {
  items: []
};

const Nav = ({ className, items, hidden, isActive, ...rest }: NavProps) => {
  return (
    <nav
      className={style(classes.root, className)}
      aria-hidden={hidden === true ? true : undefined}
      {...rest}
    >
      {items.map((item: any, index: number) => (
        <a
          key={index}
          className={style(
            classes.anchor,
            item.isActive ? classes.isActive : ""
          )}
          href={item.url}
          tabIndex={hidden === true ? -1 : undefined}
        >
          {item.linkText}
        </a>
      ))}
    </nav>
  );
};

Nav.defaultProps = defaultProps;
export default Nav;
